// === src/components/Sidebar.jsx ===
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaUserCircle } from "react-icons/fa";

const Sidebar = ({ collapsed, setCollapsed, navItems, onLogout, mobile = false, onClose }) => {
  const location = useLocation();

  const renderToggle = () => {
    if (mobile) return null;

    return (
      <button
        onClick={() => {
          const next = !collapsed;
          setCollapsed(next);
          localStorage.setItem("sidebarCollapsed", next);
        }}
        className="text-2xl text-gray-600 dark:text-gray-300 mb-6 mt-2 self-end mr-2"
      >
        {collapsed ? <FaBars /> : <FaTimes />}
      </button>
    );
  };

  return (
    <aside
      className={`${
        mobile ? "w-64 flex" : collapsed ? "w-16 hidden md:flex" : "w-64 hidden md:flex"
      } flex-col bg-white dark:bg-gray-900 text-gray-900 dark:text-white py-4 shadow transition-all duration-500 ease-in-out`}
    >
      {/* Mobile Header */}
      {mobile && (
        <div className="flex justify-between items-center px-4 mb-6">
          <h2 className="text-xl font-bold text-orange-500">Dashboard</h2>
          <button onClick={onClose} className="text-xl text-white dark:text-white">
            <FaTimes />
          </button>
        </div>
      )}

      {renderToggle()}

      {/* Navigation */}
      <nav
        className={`flex flex-col ${
          collapsed && !mobile ? "items-center" : "items-start"
        } space-y-4 w-full px-2`}
      >
        {navItems.map((item) => {
          const isActive = location.pathname.includes(item.path);
          return (
            <Link
              key={item.name}
              to={`/dashboard/${item.path}`}
              title={item.name}
              className={`group flex items-center gap-3 w-full py-2 px-3 rounded-lg transition-all duration-300 ${
                isActive
                  ? "bg-orange-500 text-white"
                  : "text-gray-600 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
              }`}
              onClick={mobile ? onClose : undefined}
            >
              {item.icon}
              {(!collapsed || mobile) && (
                <span className="text-sm font-medium">{item.name}</span>
              )}
            </Link>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="mt-auto mb-6 px-2">
        <button
          onClick={() => {
            onLogout();
            if (mobile) onClose();
          }}
          className="text-xs text-gray-400 hover:text-white flex items-center gap-2"
        >
          <FaUserCircle className="text-lg" />
          {(!collapsed || mobile) && <span>Logout</span>}
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
